import { useState } from 'react'
import { queries } from '../../resources'
import actions from '../../store/actions'
import { generateError } from '../../helpers/errors'
import { SlateCategory } from '../../resources/slate/types'
import { useDispatch } from '../redux'

export const useGetSlateCategories = () => {
    const dispatch = useDispatch()
    const [inProgress, setInProgress] = useState(false)

    const getSlateCategories = (): Promise<Array<SlateCategory>> => {
        setInProgress(true)
        return queries
            .getSlateCategories()
            .then((response) => {
                dispatch(actions.setCategories(response))
                setInProgress(false)
                return response
            })
            .catch((error) => {
                throw generateError(error)
            })
    }

    return {
        getSlateCategories,
        inProgress,
    }
}
